import script from "./ActivityCouponCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityCouponCard.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityCouponCard.vue?vue&type=style&index=0&id=1c9c7710&lang=css"

const __exports__ = script;

export default __exports__